<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">Paxel Big - Unggulan</h5>
      <br />
    </div>
    <b-card class="text-left">
      <b>Edit Paxel Big - Unggulan</b>

      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Title (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              v-validate="'required'"
              v-model="items.title.id"
              name="title_id"
              data-vv-as="Title Bahasa"
              id="input-1"
              class="form-control"
              placeholder="Title In Bahasa Indonesia"
            />
            <b-form-invalid-feedback id="input-title_id-feedback">{{
              veeErrors.first("title_id")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Title (English)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              v-validate="'required'"
              v-model="items.title.en"
              name="title_en"
              data-vv-as="Title English"
              class="form-control"
              placeholder="Title In English"
            />
            <b-form-invalid-feedback id="input-title_en-feedback">{{
              veeErrors.first("title_en")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            id="fieldset-1"
            label="Description (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <ckeditor
              :editor="editor"
              tag-name="textarea"
              placeholder="Description in Bahasa"
              v-model="items.description.id"
              data-vv-as="Description Bahasa"
              v-validate="'required'"
              name="description_id"
              class="form-control"
              :config="editorConfig"
            ></ckeditor>
            <p
              class="text-danger"
              style="width: 100%; margin-top: 0.25rem; font-size: 80%"
            >
              {{ veeErrors.first("description_id") }}
            </p>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="fieldset-1"
            label="Description (English)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <ckeditor
              :editor="editor"
              tag-name="textarea"
              placeholder="Description in English"
              v-model="items.description.en"
              v-validate="'required'"
              name="description_en"
              data-vv-as="Description English"
              class="form-control"
              :config="editorConfig"
            ></ckeditor>
            <p
              class="text-danger"
              style="width: 100%; margin-top: 0.25rem; font-size: 80%"
            >
              {{ veeErrors.first("description_en") }}
            </p>
          </b-form-group>
        </b-col>
      </b-row>

      <br />
      <b-row>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label-class="control-label mb-n1"
            class="required"
            label="Image"
            label-for="input-1"
          ></b-form-group>
          <b-card body-class="py-2 px-2">
            <card-body>
              <b-row>
                <b-col class="text-primary mt-2">
                  <i class="fas fa-paperclip"></i>&nbsp;
                  <b>{{ image.name || "Name" }}</b>
                  <sup class="text-secondary pl-3"
                    >(2 Mb)&nbsp;(500px x 500px)</sup
                  >
                </b-col>
                <b-col md="6" class="text-right" align="right">
                  <input
                    type="file"
                    ref="image"
                    name="image"
                    v-validate="
                      'image|minimalDimensions:500,500|size:2000|ext:jpg,png,gif,jpeg'
                    "
                    style="display: none"
                    v-on:change="onChangeimage()"
                  />
                  <b-button
                    @click="$refs.image.click()"
                    v-show="!image && !items.image_jpg"
                    variant="primary"
                    class="ml-5"
                    >Select File</b-button
                  >
                  <b-button
                    v-show="image || items.image_jpg"
                    variant="primary"
                    @click="modalImage = !modalImage"
                    class="mr-2"
                    >Preview</b-button
                  >
                  <b-button
                    @click="$refs.image.click()"
                    v-show="image || items.image_jpg"
                    variant="outline-primary"
                    class
                    >Change File</b-button
                  >
                </b-col>
              </b-row>
            </card-body>
          </b-card>
          <p
            class="text-danger"
            style="width: 100%; margin-top: 0.25rem; font-size: 80%"
          >
            {{ veeErrors.first("image") }}
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group id="fieldset-1" label="Status" label-for="input-1">
            <b-form-radio-group
              id="radio-group-2"
              v-model="items.status"
              :options="options2"
              name="radio-status"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <b-row class="text-right">
        <b-col md="2" class="text-left">
          <label class="text-danger">
            *
            <b class="text-dark">Required</b>
          </label>
        </b-col>
        <b-col>
          <b-button
            variant="primary"
            :disabled="loading"
            @click="put()"
            class="mr-3"
            size="lg"
          >
            Update
            <b-spinner v-if="loading" small label="Loading..."></b-spinner>
          </b-button>
          <router-link :to="{ name: 'BigExcellence' }">
            <b-button variant="outline-secondary" size="lg">Cancel</b-button>
          </router-link>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="modalImage" title="Preview Image" size="xl">
      <img
        v-show="!image"
        v-if="items.image_jpg"
        width
        height="400px"
        :src="items.image_jpg"
      />
      <img
        v-show="image"
        v-if="urlImage"
        width
        height="400px"
        :src="urlImage"
      />
    </b-modal>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {},
      widthImage: null,
      heightImage: null,
      loading: false,
      items: [],
      urlImage: "",
      modalImage: false,
      image: "",
      options2: [
        { text: "Publish", value: "publish" },
        { text: "Archive", value: "archive" },
      ],
    };
  },
  beforeCreate() {
    this.$store.dispatch(
      "PaxelBigExcellenceModule/getPaxelBigExcellence",
      this.$route.params.id
    );
  },
  created() {
    this.$store.watch(
      (state) => state.PaxelBigExcellenceModule.paxel_big_excellence_id,
      (newValue, oldValue) => {
        this.items = newValue;
        // Do whatever makes sense now
        if (this.items.length === 0) {
          this.loading = true;
        } else {
          this.loading = false;
        }
      }
    );
  },
  methods: {
    put() {
      this.$swal({
        title: "Are you sure?",
        text: "You will update this Paxel Big Excellence !",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, update it!",
      }).then((result) => {
        if (result.value) {
          this.$validator.validateAll().then((result) => {
            if (result) {
              this.loading = true;
              const formData = new FormData();
              formData.append("title_id", this.items.title.id);
              formData.append("title_en", this.items.title.en);
              formData.append("image_jpg", this.image);

              formData.append("description_id", this.items.description.id);
              formData.append("description_en", this.items.description.en);
              formData.append("status", this.items.status);
              this.$store
                .dispatch("PaxelBigExcellenceModule/putPaxelBigExcellence", {
                  id: this.$route.params.id,
                  formData,
                })
                .then((response) => {
                  this.loading = false;
                  this.$router.push({ name: "BigExcellence" });
                  this.$swal({
                    type: "success",
                    title: "Your work has been saved",
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  console.log(response);
                })
                .catch((error) => {
                  this.loading = false;
                  this.$swal({
                    type: "error",
                    title: "Oops...",
                    text: error.response.data,
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  this.serverError = error.response.data;
                  console.log(error);
                });
            } else {
              this.$swal("ERROR!", "Your file cant be submit.", "warning");
            }
          });
        }
      });
    },
    onChangeimage() {
      this.image = this.$refs.image.files[0];
      const input = this.$refs.image;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.onload = () => {
            this.widthImage = img.width;
            this.heightImage = img.height;
          };
          img.src = e.target.result;
          this.urlImage = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
  },
};
</script>

<style>
</style>
